import * as actionTypes from "./PurchaseOrderType";

const INITIAL_STATE = {
	PurchaseOrderList: [],
	orderNoList: [],
	filterVendorList: [],
	items: [],
	itemList: [],
	vendorsList: [],
	taxList: [],
	warehouseList: [],
	costcenterList: [],
	paytermsList: [],
	supplyList: [],
	purchaseOrder: null,
	vendorAddress: [],
	vendorAddressList: [],
	prjList: [],
	companyAddressList: [],
	whsAddressList: [],
	seriesList: [],
	hsnList: [],
	attachmentList: [],
	advanceFilterList: [],
	itemInfo: null,
	vendorInfo: [],
	duplicateDoc: null,
	defaultCurrency: null,
	basicFilterData: [],
	emailContent: null
};

const PurchaseOrderReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case actionTypes.SETORDERNOLIST:
			return {
				...state,
				orderNoList: action.payload.list,
			};
		case actionTypes.SETFILTERVENDORLIST:
			return {
				...state,
				filterVendorList: action.payload.list,
			};
		case actionTypes.SETPURCHASEORDERLIST:
			return {
				...state,
				PurchaseOrderList: action.payload.list,
			};
		case actionTypes.SETITEMS:
			return {
				...state,
				items: action.payload.list,
			};
		case actionTypes.SETVENDORLIST:
			return {
				...state,
				vendorsList: action.payload.list,
			};
		case actionTypes.SETCOMPANYADDRESS:
			return {
				...state,
				companyAddressList: action.payload.list,
			};
		case actionTypes.SETWHSADDRESS:
			return {
				...state,
				whsAddressList: action.payload.list,
			};
		case actionTypes.SETPAYTERMSLIST:
			return {
				...state,
				paytermsList: action.payload.list,
			};
		case actionTypes.SETSUPPLYLIST:
			return {
				...state,
				supplyList: action.payload.list,
			};
		case actionTypes.SETVENDORADDRESS:
			return {
				...state,
				vendorAddress: action.payload.list,
			};
		case actionTypes.SETVENDORADDRESSLIST:
			return {
				...state,
				vendorAddressList: action.payload.list,
			};
		case actionTypes.SETWHSELIST:
			return {
				...state,
				warehouseList: action.payload.list,
			};
		case actionTypes.SETPRJLIST:
			return {
				...state,
				prjList: action.payload.list,
			};
		case actionTypes.SETTAXLIST:
			return {
				...state,
				taxList: action.payload.list,
			};
		case actionTypes.SETCOSTCENTERLIST:
			return {
				...state,
				costcenterList: action.payload.list,
			};
		case actionTypes.SETITEMLIST:
			return {
				...state,
				itemList: action.payload,
			};
		case actionTypes.SETSERIESLIST:
			return {
				...state,
				seriesList: action.payload.list,
			};
		case actionTypes.SETHSNLIST:
			return {
				...state,
				hsnList: action.payload.list,
			};
		case actionTypes.SETPURCHASEORDER:
			return {
				...state,
				purchaseOrder: action.payload.data,
			};
		case actionTypes.SETATTACHMENTLIST:
			return {
				...state,
				attachmentList: action.payload.list,
			};
		case actionTypes.SETADVANCEFILTERLIST:
			return {
				...state,
				advanceFilterList: action.payload.list
			};
		case actionTypes.SETITEMINFO:
			return {
				...state,
				itemInfo: action.payload.data
			};
		case actionTypes.SETVENDORINFO:
			return {
				...state,
				vendorInfo: action.payload.data
			};
		case actionTypes.SETDUPLICATEDOC:
			return {
				...state,
				duplicateDoc: action.payload.data
			};
		case actionTypes.SETDEFAULTCURRENCY:
			return {
				...state,
				defaultCurrency: action.payload.data
			};
		case actionTypes.SETPURCHASEORDERBASICFILTERDATA:
			return {
				...state,
				basicFilterData: { ...action.payload }
			};
		case actionTypes.SETEMAILCONTENT:
			return {
				...state,
				emailContent: action.payload.data
			};
		case actionTypes.CLEARDOC:
			return {
				...state,
				purchaseOrder: null,
				itemList: [],
				vendorAddress: [],
				vendorAddressList: [],
				itemInfo: null,
				vendorInfo: [],
			};
		default:
			return state;
	}
};

export default PurchaseOrderReducer;